module.exports = __webpack_public_path__ + "static/media/Euro2020Final-1425.a45a811b.jpg";